<template>
  <div>
    <back-btn />
    
    <v-row justify="center">
      
      <v-col lg="10">
        <v-card class="card--shadow mb-2">
          <v-card-text>
            <patient-info :patient="patient" />
          </v-card-text>
        </v-card>
        
        <v-expansion-panels flat accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="white--text" color="purple accent-4">New Family Member</v-expansion-panel-header>
            <v-expansion-panel-content>
              <patient-family-form @emitData="submitData" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div style="margin-top:30px;" ></div>
        <v-card class="card--shadow">
          <list></list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import List from "@/components/patient/family/List.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
import PatientInfo from "../component/patientInfo.vue";
import PatientFamilyForm from '@/components/patient/family/PatientFamilyForm.vue';
import { mapState } from "vuex";

export default {
  components: {
    List,
    BackBtn,
    PatientInfo,
    PatientFamilyForm
  },
  computed: {
    ...mapState("Patient", ["patient"]),
  },
  methods: {
    submitData(data) {
      this.$store.dispatch("FamilyMember/save", data);
    },
  },
  created() {
    this.$store.dispatch("FamilyMember/getAll", this.$route.params.patient_id);

    this.$store.dispatch("Patient/getPatient", this.$route.params.patient_id);
  },
};
</script>

<style>
</style>